const DATE_LOCALES = [
  {
    key: "af",
    name: "Afrikaans",
  },
  {
    key: "am",
    name: "Amharic",
  },
  {
    key: "ar-dz",
    name: "Arabic (Algeria)",
  },
  {
    key: "ar-iq",
    name: " Arabic (Iraq)",
  },
  {
    key: "ar-kw",
    name: "Arabic (Kuwait)",
  },
  {
    key: "ar-ly",
    name: "Arabic (Lybia)",
  },
  {
    key: "ar-ma",
    name: "Arabic (Morocco)",
  },
  {
    key: "ar-sa",
    name: "Arabic (Saudi Arabia)",
  },
  {
    key: "ar-tn",
    name: " Arabic (Tunisia)",
  },
  {
    key: "ar",
    name: "Arabic",
  },
  {
    key: "az",
    name: "Azerbaijani",
  },
  {
    key: "be",
    name: "Belarusian",
  },
  {
    key: "bg",
    name: "Bulgarian",
  },
  {
    key: "bi",
    name: "Bislama",
  },
  {
    key: "bm",
    name: "Bambara",
  },
  {
    key: "bn-bd",
    name: "Bengali (Bangladesh)",
  },
  {
    key: "bn",
    name: "Bengali",
  },
  {
    key: "bo",
    name: "Tibetan",
  },
  {
    key: "br",
    name: "Breton",
  },
  {
    key: "bs",
    name: "Bosnian",
  },
  {
    key: "ca",
    name: "Catalan",
  },
  {
    key: "cs",
    name: "Czech",
  },
  {
    key: "cv",
    name: "Chuvash",
  },
  {
    key: "cy",
    name: "Welsh",
  },
  {
    key: "da",
    name: "Danish",
  },
  {
    key: "de-at",
    name: "German (Austria)",
  },
  {
    key: "de-ch",
    name: "German (Switzerland)",
  },
  {
    key: "de",
    name: "German",
  },
  {
    key: "dv",
    name: "Maldivian",
  },
  {
    key: "el",
    name: "Greek",
  },
  {
    key: "en-au",
    name: "English (Australia)",
  },
  {
    key: "en-ca",
    name: "English (Canada)",
  },
  {
    key: "en-gb",
    name: "English (United Kingdom)",
  },
  {
    key: "en-ie",
    name: "English (Ireland)",
  },
  {
    key: "en-il",
    name: "English (Israel)",
  },
  {
    key: "en-in",
    name: "English (India)",
  },
  {
    key: "en-nz",
    name: "English (New Zealand)",
  },
  {
    key: "en-sg",
    name: "English (Singapore)",
  },
  {
    key: "en-tt",
    name: "English (Trinidad & Tobago)",
  },
  {
    key: "en",
    name: "English",
  },
  {
    key: "eo",
    name: "Esperanto",
  },
  {
    key: "es-do",
    name: "Spanish (Dominican Republic)",
  },
  {
    key: "es",
    name: "Spanish",
  },
  {
    key: "et",
    name: "Estonian",
  },
  {
    key: "eu",
    name: "Basque",
  },
  {
    key: "fa",
    name: "Persian",
  },
  {
    key: "fi",
    name: "Finnish",
  },
  {
    key: "fo",
    name: "Faroese",
  },
  {
    key: "fr-ca",
    name: "French (Canada)",
  },
  {
    key: "fr-ch",
    name: "French (Switzerland)",
  },
  {
    key: "fr",
    name: "French",
  },
  {
    key: "fy",
    name: "Frisian",
  },
  {
    key: "ga",
    name: "Irish or Irish Gaelic",
  },
  {
    key: "gd",
    name: "Scottish Gaelic",
  },
  {
    key: "gl",
    name: "Galician",
  },
  {
    key: "gom-latn",
    name: "Konkani Latin script",
  },
  {
    key: "gu",
    name: "Gujarati",
  },
  {
    key: "he",
    name: "Hebrew",
  },
  {
    key: "hi",
    name: "Hindi",
  },
  {
    key: "hr",
    name: "Croatian",
  },
  {
    key: "ht",
    name: "Haitian Creole (Haiti)",
  },
  {
    key: "hu",
    name: "Hungarian",
  },
  {
    key: "hy-am",
    name: "Armenian",
  },
  {
    key: "id",
    name: "Indonesian",
  },
  {
    key: "is",
    name: "Icelandic",
  },
  {
    key: "it-ch",
    name: "Italian (Switzerland)",
  },
  {
    key: "it",
    name: "Italian",
  },
  {
    key: "ja",
    name: "Japanese",
  },
  {
    key: "jv",
    name: "Javanese",
  },
  {
    key: "ka",
    name: "Georgian",
  },
  {
    key: "kk",
    name: "Kazakh",
  },
  {
    key: "km",
    name: "Cambodian",
  },
  {
    key: "kn",
    name: "Kannada",
  },
  {
    key: "ko",
    name: "Korean",
  },
  {
    key: "ku",
    name: "Kurdish",
  },
  {
    key: "ky",
    name: "Kyrgyz",
  },
  {
    key: "lb",
    name: "Luxembourgish",
  },
  {
    key: "lo",
    name: "Lao",
  },
  {
    key: "lt",
    name: "Lithuanian",
  },
  {
    key: "lv",
    name: "Latvian",
  },
  {
    key: "me",
    name: "Montenegrin",
  },
  {
    key: "mi",
    name: "Maori",
  },
  {
    key: "mk",
    name: "Macedonian",
  },
  {
    key: "ml",
    name: "Malayalam",
  },
  {
    key: "mn",
    name: "Mongolian",
  },
  {
    key: "mr",
    name: "Marathi",
  },
  {
    key: "ms-my",
    name: "Malay",
  },
  {
    key: "ms",
    name: "Malay",
  },
  {
    key: "mt",
    name: "Maltese (Malta)",
  },
  {
    key: "my",
    name: "Burmese",
  },
  {
    key: "nb",
    name: "Norwegian Bokmål",
  },
  {
    key: "ne",
    name: "Nepalese",
  },
  {
    key: "nl-be",
    name: "Dutch (Belgium)",
  },
  {
    key: "nl",
    name: "Dutch",
  },
  {
    key: "nn",
    name: "Nynorsk",
  },
  {
    key: "oc-lnc",
    name: "Occitan, lengadocian dialecte",
  },
  {
    key: "pa-in",
    name: "Punjabi (India)",
  },
  {
    key: "pl",
    name: "Polish",
  },
  {
    key: "pt-br",
    name: "Portuguese (Brazil)",
  },
  {
    key: "pt",
    name: "Portuguese",
  },
  {
    key: "rn",
    name: "Kirundi",
  },
  {
    key: "ro",
    name: "Romanian",
  },
  {
    key: "ru",
    name: "Russian",
  },
  {
    key: "rw",
    name: "Kinyarwanda (Rwanda)",
  },
  {
    key: "sd",
    name: "Sindhi",
  },
  {
    key: "se",
    name: "Northern Sami",
  },
  {
    key: "si",
    name: "Sinhalese",
  },
  {
    key: "sk",
    name: "Slovak",
  },
  {
    key: "sl",
    name: "Slovenian",
  },
  {
    key: "sq",
    name: "Albanian",
  },
  {
    key: "sr-cyrl",
    name: "Serbian Cyrillic",
  },
  {
    key: "sr",
    name: "Serbian",
  },
  {
    key: "ss",
    name: "siSwati",
  },
  {
    key: "sv-fi",
    name: "Finland Swedish",
  },
  {
    key: "sv",
    name: "Swedish",
  },
  {
    key: "sw",
    name: "Swahili",
  },
  {
    key: "ta",
    name: "Tamil",
  },
  {
    key: "te",
    name: "Telugu",
  },
  {
    key: "tet",
    name: "Tetun Dili (East Timor)",
  },
  {
    key: "tg",
    name: "Tajik",
  },
  {
    key: "th",
    name: "Thai",
  },
  {
    key: "tk",
    name: "Turkmen",
  },
  {
    key: "tl-ph",
    name: "Tagalog (Philippines)",
  },
  {
    key: "tlh",
    name: "Klingon",
  },
  {
    key: "tr",
    name: "Turkish",
  },
  {
    key: "tzl",
    name: "Talossan",
  },
  {
    key: "tzm-latn",
    name: "Central Atlas Tamazight Latin",
  },
  {
    key: "tzm",
    name: "Central Atlas Tamazight",
  },
  {
    key: "ug-cn",
    name: "Uyghur (China)",
  },
  {
    key: "uk",
    name: "Ukrainian",
  },
  {
    key: "ur",
    name: "Urdu",
  },
  {
    key: "uz-latn",
    name: "Uzbek Latin",
  },
  {
    key: "uz",
    name: "Uzbek",
  },
  {
    key: "vi",
    name: "Vietnamese",
  },
  {
    key: "x-pseudo",
    name: "Pseudo",
  },
  {
    key: "yo",
    name: "Yoruba Nigeria",
  },
  {
    key: "zh-cn",
    name: "Chinese (China)",
  },
  {
    key: "zh-hk",
    name: "Chinese (Hong Kong)",
  },
  {
    key: "zh-tw",
    name: "Chinese (Taiwan)",
  },
  {
    key: "zh",
    name: "Chinese",
  },
  {
    key: "es-pr",
    name: "Spanish (Puerto Rico)",
  },
  {
    key: "es-mx",
    name: "Spanish (Mexico)",
  },
  {
    key: "es-us",
    name: "Spanish (United States)",
  },
];

export default DATE_LOCALES;
